import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['summary', 'form', 'thanks', 'star', 'submit', 'error', 'average', 'voteButton']
  static values = { url: String, storageKey: String }

  connect () {
    if (this.hasVoted()) this.voteButtonTarget.classList.add('hidden')
  }

  open () {
    if (this.hasVoted()) return
    this.summaryTarget.classList.add('hidden')
    this.formTarget.classList.remove('hidden')
    const picker = this.formTarget.querySelector('.recipe-rating-picker')
    picker.classList.remove('recipe-rating-picker--opening')
    requestAnimationFrame(() => picker.classList.add('recipe-rating-picker--opening'))
  }

  select (event) {
    this.score = Number(event.currentTarget.dataset.score)
    this.starTargets.forEach((star) => {
      const selected = Number(star.dataset.score) <= this.score
      star.setAttribute('aria-pressed', selected)
      star.querySelector('svg').classList.toggle('fill-white', selected)
      star.querySelector('svg').classList.toggle('fill-transparent', !selected)
    })
    this.submitTarget.disabled = false
    this.submitTarget.textContent = 'Conferma'
    this.errorTarget.textContent = ''
  }

  async submit () {
    if (!this.score || this.submitting) return

    this.submitting = true
    this.submitTarget.disabled = true
    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector("meta[name='csrf-token']")?.content || ''
        },
        body: JSON.stringify({ score: this.score })
      })
      const payload = await response.json()
      if (!response.ok && response.status !== 409) throw new Error(payload.error || 'Non è stato possibile registrare il voto.')

      localStorage.setItem(this.storageKeyValue, '1')
      if (payload.average) this.averageTarget.textContent = payload.average
      this.showThanks()
    } catch (error) {
      this.errorTarget.textContent = error.message
      this.submitTarget.disabled = false
    } finally {
      this.submitting = false
    }
  }

  showThanks () {
    this.summaryTarget.classList.add('hidden')
    this.formTarget.classList.add('hidden')
    this.thanksTarget.classList.remove('hidden')
  }

  hasVoted () {
    try {
      return localStorage.getItem(this.storageKeyValue) === '1'
    } catch (_) {
      return false
    }
  }
}
